import React from "react";

const NoticeHeader = () => {
  return (
    <div className="notice-header">
      <h2>Visit latest version of this website</h2>
      <a
        href="https://omni-mart-orpin.vercel.app/"
        target="_blank"
        rel="noreferrer"
      >
        <p>Let's go!</p>
      </a>
    </div>
  );
};

export default NoticeHeader;
